import { Ionicons } from '@expo/vector-icons';
import { StyleSheet, TouchableOpacity, TouchableOpacityProps } from 'react-native';

interface Props extends TouchableOpacityProps {
  onCloseTap?: () => void;
}

const CloseButton = (props: Props) => {
  return (
    <TouchableOpacity {...props} onPress={props.onCloseTap}>
      <Ionicons size={25} name="close" style={style.closeIcon} />
    </TouchableOpacity>
  );
};

const style = StyleSheet.create({
  closeIcon: {
    color: 'black',
    backgroundColor: '#F4F4F4',
    borderWidth: 1,
    borderColor: '#EDEDED',
    borderRadius: 26 / 2,
    overflow: 'hidden'
  }
});

export default CloseButton;
